import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, Validators } from '@angular/forms';
import { Location } from '@angular/common';

import { ModalComponent } from '../../modal/modal.component';
import { ReportAdvisePluginService } from './report-advise-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';

import * as _ from 'lodash';

@Component({
  selector: 'report-advise-edit',
  templateUrl: './report-advise-edit.component.html',
  standalone: false
})
export class ReportAdviseEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  plugin: any;
  editForm: UntypedFormGroup;
  public currentItem: any;
  public processing = false;
  private reportToRemove: number;

  @ViewChild('menuModal', { static: true }) menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true }) deleteConfirm: ConfirmComponent;
  @ViewChild('reportDeleteConfirm', { static: true }) reportDeleteConfirm: ConfirmComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: ReportAdvisePluginService,
    location: Location,
    private cdRef: ChangeDetectorRef,
    private fb: UntypedFormBuilder
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save(model: any) {
    this.processing = true;
    this.service.updateReports(this.inspectionId, this.pointId, this.pluginId, model.reports).subscribe((res) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['reports'];
  }

  add() {
    const control = <UntypedFormArray>this.editForm.controls['reports'];
    control.push(this.initReport());
  }

  initForm() {
    this.editForm = this.fb.group({
      reports: this.fb.array([])
    });

    const control = <UntypedFormArray>this.editForm.controls['reports'];
    _.forEach(this.plugin.config.ReportAdviseRemarks, (el) => {
      control.push(this.initReport(el));
    });
  }

  initReport(el?: any) {
    return this.fb.group({
      Report: new UntypedFormControl(el && el.Report ? el.Report : ''),
      Comment: new UntypedFormControl(el && el.Comment ? el.Comment : '')
    });
  }

  remove(e: any) {
    const control = <UntypedFormArray>this.editForm.controls['reports'];
    control.removeAt(this.reportToRemove);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  openReportDeleteConfirm(i: number) {
    this.reportDeleteConfirm.open();
    this.reportToRemove = i;
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId ? this.pointId : -1,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId ? this.pointId : -1,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  deletePlugin(e: any) {
    this.service.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }
}
